import { request } from './api-client';
import type { AIPrompt } from './types';

export type { AIPrompt };

export async function getPrompts(): Promise<{ data: AIPrompt[] }> {
  return request('/ai/prompts');
}

export async function getPromptVersions(id: string): Promise<{ data: AIPrompt[] }> {
  return request(`/ai/prompts/${id}/versions`);
}

export async function createPrompt(data: {
  id: string;
  providerId: string;
  model: string;
  systemPrompt: string;
  userPromptTemplate?: string;
  temperature?: number;
  maxTokens?: number;
  topP?: number;
  schemaRef?: string;
  metadata?: Record<string, unknown>;
}): Promise<{ data: AIPrompt }> {
  return request('/ai/prompts', {
    method: 'POST',
    body: JSON.stringify(data),
  });
}

export async function createPromptVersion(
  id: string,
  data: {
    providerId: string;
    model: string;
    systemPrompt: string;
    userPromptTemplate?: string;
    temperature?: number;
    maxTokens?: number;
    topP?: number;
    schemaRef?: string;
    metadata?: Record<string, unknown>;
  }
): Promise<{ data: AIPrompt }> {
  return request(`/ai/prompts/${id}/versions`, {
    method: 'POST',
    body: JSON.stringify(data),
  });
}

export async function activatePromptVersion(
  id: string,
  version: number
): Promise<{ data: { message: string; promptId: string; version: number } }> {
  return request(`/ai/prompts/${id}/activate/${version}`, {
    method: 'PUT',
  });
}

export async function deletePromptVersion(
  id: string,
  version: number
): Promise<{ data: { message: string; promptId: string; version: number } }> {
  return request(`/ai/prompts/${id}/versions/${version}`, {
    method: 'DELETE',
  });
}

export async function previewPrompt(
  id: string,
  data: { version?: number; variables: Record<string, unknown> }
): Promise<{
  data: {
    promptId: string;
    version: number;
    systemPrompt: string;
    userPrompt?: string;
    variables: Record<string, unknown>;
  };
}> {
  return request(`/ai/prompts/${id}/preview`, {
    method: 'POST',
    body: JSON.stringify(data),
  });
}
